// Path: src/constants/UserEnums.ts
// Updated to align UserRole.OLSS_COL with Firestore's lowercase 'uolss'
export const UserRole = {
  ADMIN: "admin" as const,
  OLSS_COL: "uolss" as const, // Changed from 'uOLSS' to match Firestore
  OLSLM_COL: "uolslm" as const, // Assumed lowercase, verify in Firestore
  OLSME_COL: "uolsme" as const, // Assumed lowercase, verify in Firestore
  OLSP_COL: "uolsp" as const, // Assumed lowercase, verify in Firestore
  UNAUTHORIZED: "unauthorized" as const,
};

export type UserRoleType = typeof UserRole[keyof typeof UserRole];

export default UserRole;